<template>
  <div class="VideoPreview" :class="{ isActive }">
    <div class="media" role="button" @click="$emit('playVideo')">
      <MuxVideoThumbnail
        :video="content.video"
        :animated="isActive"
        :params="{ height: 365, start: startTime, time: startTime }"
        class="image"
      />
      <img :src="playButtonText.src" class="playButton"/>
    </div>
    <div class="testimonial">
      <h4 class="title">{{ content.title }}</h4>
      <q class="quote">{{ content.quote }}</q>
      <div class="attributionLogo">
        <div class="attribution">{{ content.attribution }}</div>
        <SanityImage v-if="content.logo" :asset="content.logo.asset" class="logo" />
      </div>
    </div>
  </div>
</template>

<script setup>
import playButtonText from "~/assets/ui/play-button-text.svg"

import MuxVideoThumbnail from "../../elems/MuxVideoThumbnail.vue"

const { content, isActive } = defineProps({
  content: Object,
  isActive: Boolean,
})

const startTime = content.previewStartTime ?? 10
</script>

<style scoped>

.VideoPreview {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  border: thin solid #e7e7e7;
  width: 37rem;
  max-width: 80vw;
  display: flex;
  flex-direction: column;
}

.media {
  display: grid;
  place-items: center;
}

.media > * {
  grid-row: 1;
  grid-column: 1;
}

.testimonial {
  flex-grow: 1;
  padding: var(--spacing-8) var(--spacing-6) var(--spacing-5);
  display: flex;
  flex-direction: column;
}

.title {
  font-weight: 600;
  font-size: var(--font-size-2);
  line-height: 1;
  color: var(--brand-color);
}

.quote {
  margin-top: var(--spacing-0);
  display: block;
  max-width: 29rem;
  font-weight: 500;
  font-size: var(--font-size-4);
  font-style: italic;
  line-height: 1.4;
  color: var(--text-color-black);
}

.attributionLogo {
  margin-top: auto;
  padding-top: var(--spacing-1);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.attribution {
  font-weight: 600;
  font-size: var(--font-size-2);
  line-height: 1;
  color: var(--text-color-black);
}

.logo {
  height: 2.5rem;
}
</style>
